import { CheckCircleOutline, ErrorOutline } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React, { ReactNode } from "react";
import toast, { ToastPosition } from "react-hot-toast";

// Default duration in milliseconds (4 seconds)
const DEFAULT_DURATION = 4000;

export class Toast {
  static error(msg: string, duration: number = DEFAULT_DURATION, position?: ToastPosition) {
    toast.error(msg, { duration, position, style: { fontSize: "20px", padding: "24px", minWidth: "400px" } });
  }

  static success(msg: string, duration: number = DEFAULT_DURATION, position?: ToastPosition) {
    toast.success(msg, { duration, position, style: { fontSize: "20px", padding: "24px", minWidth: "400px" } });
  }

  static warn(msg: string, duration: number = DEFAULT_DURATION) {
    toast(msg, { duration, style: { fontSize: "20px", padding: "24px", minWidth: "400px" } });
  }
}

export class WebToast {
  static error(msg: string, duration: number = DEFAULT_DURATION) {
    toast.error(msg, {
      duration,
      position: "bottom-left",
      style: { fontSize: "20px", padding: "24px", minWidth: "400px" },
    });
  }

  static success(msg: string, duration: number = DEFAULT_DURATION) {
    toast.success(msg, {
      duration,
      position: "bottom-left",
      style: { fontSize: "20px", padding: "24px", minWidth: "400px" },
    });
  }

  static warn(msg: string, duration: number = DEFAULT_DURATION) {
    toast(msg, { duration, position: "bottom-left", style: { fontSize: "20px", padding: "24px", minWidth: "400px" } });
  }
}

export class WebToastColoredWithTitle {
  static error(title: string, msg: string, duration: number = DEFAULT_DURATION) {
    toast.error(
      <Box sx={{ display: "flex", gap: 1.5 }}>
        <ErrorOutline sx={{ color: "error.main", fontSize: 32 }} />
        <Box sx={{ display: "flex", flexDirection: "column", gap: "6px" }}>
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: "bold",
              color: "error.dark",
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: "18px",
              color: "error.dark",
            }}
          >
            {msg}
          </Typography>
        </Box>
      </Box>,
      { duration, position: "bottom-left", icon: null, style: { padding: "28px", minWidth: "450px" } }
    );
  }

  static success(
    title: string,
    options?: { msg?: string; duration?: number; position?: ToastPosition; actions?: ReactNode }
  ) {
    toast.success(
      <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
        <CheckCircleOutline sx={{ color: "success.main", fontSize: 32 }} />
        <Box sx={{ display: "flex", flexDirection: "column", gap: "6px" }}>
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: "bold",
              color: "success.dark",
            }}
          >
            {title}
          </Typography>
          {options?.msg && (
            <Typography
              sx={{
                fontSize: "18px",
                color: "success.dark",
              }}
            >
              {options?.msg}
            </Typography>
          )}
        </Box>
        {options?.actions}
      </Box>,
      {
        duration: options?.duration ?? DEFAULT_DURATION,
        position: options?.position ?? "bottom-left",
        icon: null,
        style: { backgroundColor: "#EDF7ED", padding: "28px", minWidth: "450px" },
      }
    );
  }
}
